module.exports = __webpack_public_path__ + "static/cliente_10-174089f936ab53034fd7c68eab2b644e.png";